// extracted by mini-css-extract-plugin
export default {"root":"Button_ContentTextSizeLargeTyp_root__Jsg5k","button":"Button_ContentTextSizeLargeTyp_button__Ht33c"};